import React from "react";
import { CheckCircle2, XCircle, Lightbulb, PhoneCall } from "lucide-react";

const BREAKDOWN = [
  { k: "digital_presence", l: "Digital Presence" },
  { k: "business_potential", l: "Business Potential" },
  { k: "need", l: "Need" },
  { k: "fit", l: "Fit" },
  { k: "acquisition_potential", l: "Acquisition" },
];

export const AuditTab = ({ p }) => {
  if (!p.ai_analyzed) {
    return (
      <div className="rounded-xl border border-dashed border-border p-6 text-center text-sm text-muted-foreground">
        Nessuna analisi AI ancora. Premi <b>Analizza con AI</b> per ottenere score, audit e servizio consigliato.
      </div>
    );
  }
  const breakdown = p.score_breakdown || {};
  return (
    <>
      {p.ai_used_real && (
        <div className="flex items-center gap-2 rounded-lg border border-[#22C55E]/30 bg-[#22C55E]/5 px-3 py-2 text-xs text-[#22C55E]" data-testid="real-data-badge">
          <CheckCircle2 className="h-3.5 w-3.5" /> Analisi basata sui dati Instagram reali
        </div>
      )}
      <div className="grid grid-cols-3 gap-3">
        <Metric label="20/80 Score" value={Math.round(p.score)} />
        <Metric label="Opportunity" value={Math.round(p.opportunity_score)} />
        <Metric label="Acquisition" value={Math.round(p.acquisition_score)} />
      </div>
      <div className="space-y-2 rounded-xl border border-border p-4">
        <div className="label-caps text-muted-foreground">Breakdown 20/80</div>
        {BREAKDOWN.map((b) => (
          <div key={b.k} className="space-y-1">
            <div className="flex justify-between text-xs"><span>{b.l}</span><span className="tabular-nums">{breakdown[b.k] || 0}/20</span></div>
            <div className="h-1.5 w-full rounded bg-secondary">
              <div className="h-full rounded bg-primary" style={{ width: `${((breakdown[b.k] || 0) / 20) * 100}%` }} />
            </div>
          </div>
        ))}
      </div>
      <AuditRow icon={CheckCircle2} color="#22C55E" title="Cosa funziona" text={p.audit_funziona} />
      <AuditRow icon={XCircle} color="#EF4444" title="Cosa non funziona" text={p.audit_non_funziona} />
      <AuditRow icon={Lightbulb} color="#EAB308" title="Cosa potremmo fare" text={p.audit_potremmo_fare} />
      <div className="grid grid-cols-2 gap-3">
        <InfoBox label="Servizio consigliato" value={p.servizio_consigliato} highlight />
        <InfoBox label="Budget stimato" value={p.budget_potenziale} />
      </div>
      {p.script_telefonico && (
        <div className="rounded-xl border border-primary/30 bg-primary/5 p-4">
          <div className="mb-2 flex items-center gap-2 label-caps text-primary"><PhoneCall className="h-3.5 w-3.5" /> Script telefonico</div>
          <p className="text-sm italic leading-relaxed">"{p.script_telefonico}"</p>
        </div>
      )}
    </>
  );
};

function Metric({ label, value }) {
  return (
    <div className="rounded-xl border border-border p-3 text-center">
      <div className="font-heading text-2xl font-bold text-primary tabular-nums">{value}</div>
      <div className="label-caps mt-1 text-muted-foreground">{label}</div>
    </div>
  );
}

function AuditRow({ icon: Icon, color, title, text }) {
  if (!text) return null;
  return (
    <div className="flex gap-3 rounded-xl border border-border p-3">
      <Icon className="mt-0.5 h-4 w-4 shrink-0" style={{ color }} />
      <div>
        <div className="text-xs font-semibold" style={{ color }}>{title}</div>
        <p className="mt-0.5 text-sm leading-relaxed text-foreground/90">{text}</p>
      </div>
    </div>
  );
}

function InfoBox({ label, value, highlight }) {
  return (
    <div className={`rounded-xl border p-3 ${highlight ? "border-primary/40 bg-primary/5" : "border-border"}`}>
      <div className="label-caps text-muted-foreground">{label}</div>
      <div className={`mt-1 text-sm font-medium ${highlight ? "text-primary" : ""}`}>{value || "—"}</div>
    </div>
  );
}
